import {Component, OnInit} from '@angular/core';
import {ActivatedRouteSnapshot, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {EventBusService} from './common.module/util/event-bus.service';
import {environment} from '../environments/environment';
import {ToastService} from "ng-uikit-pro-standard";
import {DbBaseRepository} from "./common.module/util/db.base.repository";

@Component({
  selector: 'app-root',
  template: `
    <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.15" [maximum]="1" [speed]="'200'" [showSpinner]="'false'"
                 [direction]="'leftToRightIncreased'" [trickleSpeed]="250" [thick]="false" [ease]="'linear'"
                 [color]="'#00e2ff'"></ng-progress>
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {

  constructor(private router: Router,
              private titleSrv: Title,
              private eb: EventBusService,
              private toastMsg: ToastService,
              private dbBaseRepository: DbBaseRepository) {
  }

  ngOnInit() {
    this.dbBaseRepository.initDB();
    this.eventTitleSubscriber();
    this.eb.connect(environment.apiBaseUrl + '/ws/eb/', {});
    this.eb.close.subscribe(() => {
      console.log('Hemos cerrado la sesión');
      this.toastMsg.warning('Se ha detectado inestabilidad en su red, tengalo en cuenta.');

    });
    this.eb.open.subscribe(() => {
      console.log('Estamos conectados.');
    });
  }

  /**
   * Modificación del titulo de la aplicacion
   *
   * @param routeSnapshot
   * @returns {string}
   */
  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'App';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private eventTitleSubscriber() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let title: string = this.getPageTitle(this.router.routerState.snapshot.root);
        if (!title && this.titleSrv.getTitle()) {
          title = this.titleSrv.getTitle();
        }
        this.titleSrv.setTitle(title);
      }
    });
  }
}
